import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'motors-illustration-boat',
    templateUrl: './motors-illustration-boat.component.html',
    styleUrls: ['./motors-illustration-boat.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotorsIllustrationBoatComponent {}
